export const NOTIFY_DEFAULT_MESSAGE: Record<'error' | 'success', string> = {
  error: 'Copy to clipboard failed. Please try again',
  success: 'Copied to clipboard successfully',
};
